
import Vue from "vue";
import * as types from "@/store/mutation-types";
import { FormBlock } from "@/components/FormBuilder/types";
import { roofStructureFormSchema } from "@/forms/admin/roofStructure";
import {
  roofStructureMapActions,
  roofStructureMapMutations,
  roofStructureMapState
} from "@/store/modules/roofStructure";

export default Vue.extend({
  name: "CreateRoofStructureView",
  data() {
    return {
      isLoading: false,
      loadingText: "",
      errorMessage: "",
      successMessage: "",
      disablePrimaryButton: true
    };
  },
  created() {
    this.SET_EDIT({} as any);
  },
  destroyed() {
    this.SET_EDIT(" " as any);
  },
  computed: {
    ...roofStructureMapState(["editing", "makingApiRequest"]),
    roofStructureFields(): FormBlock[] {
      return roofStructureFormSchema;
    }
  },
  methods: {
    ...roofStructureMapMutations(["SET_EDIT"]),
    ...roofStructureMapMutations({ editField: types.SET_EDIT_FIELD }),
    ...roofStructureMapActions(["createRoofStructure"]),
    validationChangeHandler(e: any) {
      const { formIsValid } = e;
      this.disablePrimaryButton = !formIsValid;
    },
    formFieldChangeHandler({ key, value }: { key: any; value: any }) {
      this.editField({ key, value });
    },
    async toolbarSelectItem(event: string) {
      switch (event) {
        case "saveRoofStructure":
          await this.submit();
          break;
        case "cancelRoofStructure":
          this.$router.push("/admin/roofStructures").catch(() => {});
          break;
      }
    },
    async submit(): Promise<void> {
      try {
        this.loadingText = "Creating roof structure. Please wait...";
        this.isLoading = true;
        await this.createRoofStructure({
          label: this.editing?.label,
          value: this.editing?.value
        });
        this.$appNotifySuccess("Roof Structure created");
        this.$router.replace("/admin/roofStructures");
      } catch (error) {
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
      } finally {
        this.isLoading = false;
        this.loadingText = "";
      }
    }
  }
});
